/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  GetDownloadMultipleDriverDataParams,
  GetDownloadMultipleVehicleDataParams,
  GetDownloadSingleDriverDataParams,
  GetDownloadSingleVehicleDataParams,
  GetStatusHistoryForTargetParams,
  GetTachographDriverDataParams,
  GetTachographVehicleDataParams,
  SendDriverDataToAddressParams,
  SendVehicleDataToAddressParams,
  StreamingResponseBody,
  TachographDriverResponseDTO,
  TachographStatesInDay,
  TachographVehicleResponseDTO
} from '../../model';





/**
 * @summary Get the tachograph data of all vehicles that contains tachograph
 */
export const getTachographVehicleData = (
    params: GetTachographVehicleDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TachographVehicleResponseDTO[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/vehicleData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetTachographVehicleDataQueryKey = (params?: GetTachographVehicleDataParams,) => {
    return [
    `/api/v1.1/tachograph/vehicleData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTachographVehicleDataQueryOptions = <TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(params: GetTachographVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTachographVehicleDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTachographVehicleData>>> = ({ signal }) => getTachographVehicleData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTachographVehicleDataQueryResult = NonNullable<Awaited<ReturnType<typeof getTachographVehicleData>>>
export type GetTachographVehicleDataQueryError = AxiosError<unknown>


export function useGetTachographVehicleData<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTachographVehicleData>>,
          TError,
          Awaited<ReturnType<typeof getTachographVehicleData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographVehicleData<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTachographVehicleData>>,
          TError,
          Awaited<ReturnType<typeof getTachographVehicleData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographVehicleData<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph data of all vehicles that contains tachograph
 */

export function useGetTachographVehicleData<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTachographVehicleDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTachographVehicleDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(params: GetTachographVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTachographVehicleDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTachographVehicleData>>> = ({ signal }) => getTachographVehicleData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTachographVehicleDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTachographVehicleData>>>
export type GetTachographVehicleDataSuspenseQueryError = AxiosError<unknown>


export function useGetTachographVehicleDataSuspense<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographVehicleDataSuspense<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographVehicleDataSuspense<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph data of all vehicles that contains tachograph
 */

export function useGetTachographVehicleDataSuspense<TData = Awaited<ReturnType<typeof getTachographVehicleData>>, TError = AxiosError<unknown>>(
 params: GetTachographVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTachographVehicleDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for getting target tachograph data in timeline grouped by days.
 * @summary Get target tachograph diagram data
 */
export const getStatusHistoryForTarget = (
    params: GetStatusHistoryForTargetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TachographStatesInDay>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/status-history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetStatusHistoryForTargetQueryKey = (params?: GetStatusHistoryForTargetParams,) => {
    return [
    `/api/v1.1/tachograph/status-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetStatusHistoryForTargetQueryOptions = <TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatusHistoryForTargetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatusHistoryForTarget>>> = ({ signal }) => getStatusHistoryForTarget(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatusHistoryForTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getStatusHistoryForTarget>>>
export type GetStatusHistoryForTargetQueryError = AxiosError<void>


export function useGetStatusHistoryForTarget<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatusHistoryForTarget>>,
          TError,
          Awaited<ReturnType<typeof getStatusHistoryForTarget>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatusHistoryForTarget<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatusHistoryForTarget>>,
          TError,
          Awaited<ReturnType<typeof getStatusHistoryForTarget>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatusHistoryForTarget<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target tachograph diagram data
 */

export function useGetStatusHistoryForTarget<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatusHistoryForTargetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetStatusHistoryForTargetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatusHistoryForTargetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatusHistoryForTarget>>> = ({ signal }) => getStatusHistoryForTarget(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatusHistoryForTargetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStatusHistoryForTarget>>>
export type GetStatusHistoryForTargetSuspenseQueryError = AxiosError<void>


export function useGetStatusHistoryForTargetSuspense<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatusHistoryForTargetSuspense<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatusHistoryForTargetSuspense<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target tachograph diagram data
 */

export function useGetStatusHistoryForTargetSuspense<TData = Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError = AxiosError<void>>(
 params: GetStatusHistoryForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatusHistoryForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatusHistoryForTargetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Send the tachograph file in .ddd attachment for the requested address
 */
export const sendVehicleDataToAddress = (
    params: SendVehicleDataToAddressParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/sendVehicleDataToAddress`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getSendVehicleDataToAddressQueryKey = (params?: SendVehicleDataToAddressParams,) => {
    return [
    `/api/v1.1/tachograph/sendVehicleDataToAddress`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSendVehicleDataToAddressQueryOptions = <TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSendVehicleDataToAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sendVehicleDataToAddress>>> = ({ signal }) => sendVehicleDataToAddress(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SendVehicleDataToAddressQueryResult = NonNullable<Awaited<ReturnType<typeof sendVehicleDataToAddress>>>
export type SendVehicleDataToAddressQueryError = AxiosError<unknown>


export function useSendVehicleDataToAddress<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sendVehicleDataToAddress>>,
          TError,
          Awaited<ReturnType<typeof sendVehicleDataToAddress>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendVehicleDataToAddress<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sendVehicleDataToAddress>>,
          TError,
          Awaited<ReturnType<typeof sendVehicleDataToAddress>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendVehicleDataToAddress<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Send the tachograph file in .ddd attachment for the requested address
 */

export function useSendVehicleDataToAddress<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSendVehicleDataToAddressQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSendVehicleDataToAddressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSendVehicleDataToAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sendVehicleDataToAddress>>> = ({ signal }) => sendVehicleDataToAddress(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SendVehicleDataToAddressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof sendVehicleDataToAddress>>>
export type SendVehicleDataToAddressSuspenseQueryError = AxiosError<unknown>


export function useSendVehicleDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendVehicleDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendVehicleDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Send the tachograph file in .ddd attachment for the requested address
 */

export function useSendVehicleDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendVehicleDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendVehicleDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSendVehicleDataToAddressSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Send the tachograph file in .ddd attachment for the requested address
 */
export const sendDriverDataToAddress = (
    params: SendDriverDataToAddressParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/sendDriverDataToAddress`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getSendDriverDataToAddressQueryKey = (params?: SendDriverDataToAddressParams,) => {
    return [
    `/api/v1.1/tachograph/sendDriverDataToAddress`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSendDriverDataToAddressQueryOptions = <TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(params: SendDriverDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSendDriverDataToAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sendDriverDataToAddress>>> = ({ signal }) => sendDriverDataToAddress(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SendDriverDataToAddressQueryResult = NonNullable<Awaited<ReturnType<typeof sendDriverDataToAddress>>>
export type SendDriverDataToAddressQueryError = AxiosError<unknown>


export function useSendDriverDataToAddress<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sendDriverDataToAddress>>,
          TError,
          Awaited<ReturnType<typeof sendDriverDataToAddress>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendDriverDataToAddress<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sendDriverDataToAddress>>,
          TError,
          Awaited<ReturnType<typeof sendDriverDataToAddress>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendDriverDataToAddress<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Send the tachograph file in .ddd attachment for the requested address
 */

export function useSendDriverDataToAddress<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSendDriverDataToAddressQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSendDriverDataToAddressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(params: SendDriverDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSendDriverDataToAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sendDriverDataToAddress>>> = ({ signal }) => sendDriverDataToAddress(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SendDriverDataToAddressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof sendDriverDataToAddress>>>
export type SendDriverDataToAddressSuspenseQueryError = AxiosError<unknown>


export function useSendDriverDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendDriverDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSendDriverDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Send the tachograph file in .ddd attachment for the requested address
 */

export function useSendDriverDataToAddressSuspense<TData = Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError = AxiosError<unknown>>(
 params: SendDriverDataToAddressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof sendDriverDataToAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSendDriverDataToAddressSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get the tachograph data of all drivers that have tachographcard
 */
export const getTachographDriverData = (
    params: GetTachographDriverDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TachographDriverResponseDTO[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/driverData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetTachographDriverDataQueryKey = (params?: GetTachographDriverDataParams,) => {
    return [
    `/api/v1.1/tachograph/driverData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTachographDriverDataQueryOptions = <TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(params: GetTachographDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTachographDriverDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTachographDriverData>>> = ({ signal }) => getTachographDriverData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTachographDriverDataQueryResult = NonNullable<Awaited<ReturnType<typeof getTachographDriverData>>>
export type GetTachographDriverDataQueryError = AxiosError<unknown>


export function useGetTachographDriverData<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTachographDriverData>>,
          TError,
          Awaited<ReturnType<typeof getTachographDriverData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographDriverData<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTachographDriverData>>,
          TError,
          Awaited<ReturnType<typeof getTachographDriverData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographDriverData<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph data of all drivers that have tachographcard
 */

export function useGetTachographDriverData<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTachographDriverDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTachographDriverDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(params: GetTachographDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTachographDriverDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTachographDriverData>>> = ({ signal }) => getTachographDriverData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTachographDriverDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTachographDriverData>>>
export type GetTachographDriverDataSuspenseQueryError = AxiosError<unknown>


export function useGetTachographDriverDataSuspense<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographDriverDataSuspense<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTachographDriverDataSuspense<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph data of all drivers that have tachographcard
 */

export function useGetTachographDriverDataSuspense<TData = Awaited<ReturnType<typeof getTachographDriverData>>, TError = AxiosError<unknown>>(
 params: GetTachographDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTachographDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTachographDriverDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get the tachograph file in .ddd format for the selected vehicles
 */
export const getDownloadSingleVehicleData = (
    params: GetDownloadSingleVehicleDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StreamingResponseBody>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/downloadSingleVehicleData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDownloadSingleVehicleDataQueryKey = (params?: GetDownloadSingleVehicleDataParams,) => {
    return [
    `/api/v1.1/tachograph/downloadSingleVehicleData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDownloadSingleVehicleDataQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadSingleVehicleDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>> = ({ signal }) => getDownloadSingleVehicleData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadSingleVehicleDataQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>>
export type GetDownloadSingleVehicleDataQueryError = AxiosError<unknown>


export function useGetDownloadSingleVehicleData<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadSingleVehicleData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadSingleVehicleData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleVehicleData<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadSingleVehicleData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadSingleVehicleData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleVehicleData<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected vehicles
 */

export function useGetDownloadSingleVehicleData<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadSingleVehicleDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDownloadSingleVehicleDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadSingleVehicleDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>> = ({ signal }) => getDownloadSingleVehicleData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadSingleVehicleDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>>
export type GetDownloadSingleVehicleDataSuspenseQueryError = AxiosError<unknown>


export function useGetDownloadSingleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected vehicles
 */

export function useGetDownloadSingleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadSingleVehicleDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get the tachograph file in .ddd format for the selected driver
 */
export const getDownloadSingleDriverData = (
    params: GetDownloadSingleDriverDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StreamingResponseBody>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/downloadSingleDriverData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDownloadSingleDriverDataQueryKey = (params?: GetDownloadSingleDriverDataParams,) => {
    return [
    `/api/v1.1/tachograph/downloadSingleDriverData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDownloadSingleDriverDataQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadSingleDriverDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadSingleDriverData>>> = ({ signal }) => getDownloadSingleDriverData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadSingleDriverDataQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadSingleDriverData>>>
export type GetDownloadSingleDriverDataQueryError = AxiosError<unknown>


export function useGetDownloadSingleDriverData<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadSingleDriverData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadSingleDriverData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleDriverData<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadSingleDriverData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadSingleDriverData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleDriverData<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected driver
 */

export function useGetDownloadSingleDriverData<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadSingleDriverDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDownloadSingleDriverDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadSingleDriverDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadSingleDriverData>>> = ({ signal }) => getDownloadSingleDriverData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadSingleDriverDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadSingleDriverData>>>
export type GetDownloadSingleDriverDataSuspenseQueryError = AxiosError<unknown>


export function useGetDownloadSingleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadSingleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected driver
 */

export function useGetDownloadSingleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadSingleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadSingleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadSingleDriverDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get the tachograph file in .ddd format for the selected vehicle
 */
export const getDownloadMultipleVehicleData = (
    params: GetDownloadMultipleVehicleDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StreamingResponseBody>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/downloadMultipleVehicleData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDownloadMultipleVehicleDataQueryKey = (params?: GetDownloadMultipleVehicleDataParams,) => {
    return [
    `/api/v1.1/tachograph/downloadMultipleVehicleData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDownloadMultipleVehicleDataQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadMultipleVehicleDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>> = ({ signal }) => getDownloadMultipleVehicleData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadMultipleVehicleDataQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>>
export type GetDownloadMultipleVehicleDataQueryError = AxiosError<unknown>


export function useGetDownloadMultipleVehicleData<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleVehicleData<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleVehicleData<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected vehicle
 */

export function useGetDownloadMultipleVehicleData<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadMultipleVehicleDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDownloadMultipleVehicleDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadMultipleVehicleDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>> = ({ signal }) => getDownloadMultipleVehicleData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadMultipleVehicleDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>>
export type GetDownloadMultipleVehicleDataSuspenseQueryError = AxiosError<unknown>


export function useGetDownloadMultipleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected vehicle
 */

export function useGetDownloadMultipleVehicleDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleVehicleDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleVehicleData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadMultipleVehicleDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get the tachograph file in .ddd format for the selected drivers
 */
export const getDownloadMultipleDriverData = (
    params: GetDownloadMultipleDriverDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StreamingResponseBody>> => {
    
    
    return axios.default.get(
      `/api/v1.1/tachograph/downloadMultipleDriverData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDownloadMultipleDriverDataQueryKey = (params?: GetDownloadMultipleDriverDataParams,) => {
    return [
    `/api/v1.1/tachograph/downloadMultipleDriverData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDownloadMultipleDriverDataQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadMultipleDriverDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>> = ({ signal }) => getDownloadMultipleDriverData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadMultipleDriverDataQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>>
export type GetDownloadMultipleDriverDataQueryError = AxiosError<unknown>


export function useGetDownloadMultipleDriverData<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadMultipleDriverData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadMultipleDriverData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleDriverData<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadMultipleDriverData>>,
          TError,
          Awaited<ReturnType<typeof getDownloadMultipleDriverData>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleDriverData<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected drivers
 */

export function useGetDownloadMultipleDriverData<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadMultipleDriverDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDownloadMultipleDriverDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadMultipleDriverDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>> = ({ signal }) => getDownloadMultipleDriverData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadMultipleDriverDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>>
export type GetDownloadMultipleDriverDataSuspenseQueryError = AxiosError<unknown>


export function useGetDownloadMultipleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadMultipleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the tachograph file in .ddd format for the selected drivers
 */

export function useGetDownloadMultipleDriverDataSuspense<TData = Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError = AxiosError<unknown>>(
 params: GetDownloadMultipleDriverDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDownloadMultipleDriverData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadMultipleDriverDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




